import { gsap, ScrollTrigger } from "../../../gsap";
import {
  circlesHorizontalAnimationInit,
  circlesHorizontalAnimation,
} from "./icon-based/circlesHorizontal";
import Dom from "../../../dom";

export const InitializeCalloutScroll = () => {
  if (Dom.prefersMotion) {
    gsap.registerPlugin(ScrollTrigger);
    const callouts = document.querySelectorAll(".callout");
    callouts.forEach((c) => {
      if (ScrollTrigger.isInViewport(c)) {
        c.classList.add("active");
        return;
      }
      const text = c.querySelector("p");
      const svg = c.querySelector("svg");
      const isHorizontal = svg !== null && svg.parentNode.classList.contains("horizontal");
      var tl = gsap.timeline({ duration: 1, ease: "power2.inOut" });
      const { ringOne, ringTwo, ringThree } = isHorizontal && circlesHorizontalAnimationInit(svg, tl);
      tl.set(text, {
        opacity: 0,
      });

      ScrollTrigger.create({
        // markers: 1,
        // id: "callout",
        trigger: c,
        start: "top 75%",
        end: "bottom 75%",
        onEnter: () => {
          let delay = "-=0";
          if (isHorizontal) {
            delay = "-=.9";
            circlesHorizontalAnimation({ ringOne, ringTwo, ringThree }, tl);
          }
          setTimeout(() => {
            c.classList.add("active");
          }, 200);
          tl.to(
            text,
            {
              duration: 1,
              opacity: 1,
            },
            delay
          );
        },
        //   onLeave: () => c.classList.remove("active"),
        //   onEnterBack: () => c.classList.add("active"),
        //   onLeaveBack: () => c.classList.remove("active"),
      });
    });
  }
};
